import React, {FC} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

//TYPES
export type InfoBoxProps = {
  label: string,
  value?: number | string,
  valueSuffix?: string
};

const InfoBox: FC<InfoBoxProps> = ({label, value, valueSuffix}) => {
  return <Box sx={styles.localizationBox}>
    <Typography variant="body2" sx={{color: 'text.secondary', pl: 0.5, textAlign: 'center'}}>{label}</Typography>
    <Typography variant="body1" sx={{fontWeight: 700}}>{value || '-'} {value ? valueSuffix : undefined}</Typography>
  </Box>;
};
export default InfoBox;

const styles = {
  localizationBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    bgcolor: 'grey.200',
    p: 1,
    flex: '1 1 auto',
    height: '70px',
    borderRadius: 1
  }
};